'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from '@/contexts/InAppProvider';
import { ContestPage } from 'app/(appHeader)/promotions/2023-pick-and-choo/ContestPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');

  return (
    <>
      <title>프롤로그 픽앤츄 with RIDI | 디리토</title>
      <meta property="og:type" content="website" key="type" />
      <meta property="og:title" content={'프롤로그 픽앤츄 with RIDI | 디리토'} key="title" />
      <meta property="og:site_name" content="디리토" key="site_name" />
      <meta property="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta property="twitter:site" content="@diritto_kr" key="twitter:site" />
      <ContestPage isApp={isApp} />
    </>
  );
}
